module.exports = __webpack_public_path__ + "static/img/rank-2.6738dd85.svg";